import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
    from {
        transform: translateY(-100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const slideUp = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-100%);
        opacity: 0;
    }
`;

const Container = styled.div`
    position: fixed;
    top: -1px;
    left: -1px;
    width: fit-content;
    z-index: 9999;
    
    display: flex;
    align-items: center;
    gap: 8px;
    
    padding: 12px 20px;
    border-radius: 0 0 8px 8px;
    
    background-color: ${props => 
        props.$isOnline 
            ? props.$wasOffline 
                ? '#28a745' // 초록색 (복구됨)
                : 'transparent'
            : '#dc3545' // 빨간색 (오프라인)
    };
    
    color: white;
    font-weight: 500;
    font-size: 14px;
    
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    
    animation: ${slideDown} 0.3s ease-out;
    
    ${props => props.$isOnline && !props.$wasOffline && `
        animation: ${slideUp} 0.3s ease-out;
    `}
`;

const Icon = styled.span`
    font-size: 16px;
`;

const Message = styled.span`
    white-space: nowrap;
    color: #fff;
`;

const Style = {
    Container,
    Icon,
    Message
};

export default Style;
